<template>
  <div class="v-data-footer">
    <v-row class="pt-5">
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-select
          v-model="exportSelected"
          :menu-props="{ offsetY: true }"
          outlined
          dense
          label="Export"
          :items="exportTypes"
          item-text="name"
          item-value="value"
          data-cy="exportSelect"
        />
      </v-col>

      <v-col cols="auto">
        <v-btn
          :disabled="disabledExportButton"
          height="40"
          color="primary"
          :loading="exportLoading"
          depressed
          @click="exportData($event)"
        >
          Export
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import requestUrlFunction from '@/utils/requestUrl'
import { downloadFile } from '../mixins/downloadFile'

export default {
  name: 'CustomersExportFooter',
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      exportSelected: null,
      exportLoading: false,
    }
  },
  computed: {
    exportTypes() {
      return [
        {
          name: 'Exportovat zobrazená data',
          value: 'showedData',
        },
        {
          name: 'Exportovat vybraná data',
          value: 'selectedData',
          disabled: !this.selectedIds.length,
        },
        {
          name: 'Exportovat všechna data',
          value: 'allData',
        },
      ]
    },
    selectedIds() {
      return this.value.selectedData.items.map((item) => item.id)
    },
    failedIds() {
      return this.value.selectedData.items.filter(
        (item) => item.status.name !== 'NEW' && item.status.name !== 'PROCESSING'
      )
    },
    disabledExportButton() {
      if (!this.exportSelected) {
        return true
      }
      if (this.exportSelected === 'selectedData' && !this.selectedIds.length) {
        return true
      }
      return false
    },
  },
  methods: {
    exportData(event) {
      this.exportLoading = true

      if (this.exportSelected === 'showedData') {
        this.downloadFile(
          event,
          `customer/export${requestUrlFunction(this.value.selectedData.params)}`
        ).finally(() => {
          this.exportLoading = false
        })
      } else if (this.exportSelected === 'selectedData') {
        const ids = this.value.selectedData.items.map((item) => item.id).join('&ids=')

        this.downloadFile(event, `customer/export?ids=${ids}`).finally(() => {
          this.exportLoading = false
        })
      } else if (this.exportSelected === 'allData') {
        this.downloadFile(
          event,
          `customer/export${requestUrlFunction(
            this.value.selectedData.params,
            this.value.totalElements
          )}`
        ).finally(() => {
          this.exportLoading = false
        })
      }
    },
  },
}
</script>
